import { AUTH_EVENT } from 'constants/events';
import { TIMEOUT_DELAY } from 'constants/general';
import { isNativeTokenRequestInProgress } from 'bridge/native-auth.bridge';
import { useWindowEventListener } from 'hooks/useWindowEventListener';
import { t } from 'services/i18n.service';
import { useEffect, useState } from 'react';

const titleKeys = [
  'lazy_load_placeholder.fetching_your_settings_hold_tight',
  'lazy_load_placeholder.connecting_to_the_Focus_Bear_control_panel',
  'lazy_load_placeholder.calibrating_your_productivity_dashboard',
  'lazy_load_placeholder.debugging_distractions_stand_by'
] as const;

const pickRandomTitleKey = (): (typeof titleKeys)[number] =>
  titleKeys[Math.floor(Math.random() * titleKeys.length)];

const InitEmbeddedServices = () => {
  const [titleKey, setTitleKey] = useState(pickRandomTitleKey);
  const [isRefreshingSignIn, setIsRefreshingSignIn] = useState(
    isNativeTokenRequestInProgress()
  );

  useWindowEventListener(AUTH_EVENT.TOKEN_REQUEST_STARTED, () => {
    setIsRefreshingSignIn(true);
  });

  useWindowEventListener(
    [AUTH_EVENT.TOKEN_REQUEST_ENDED, AUTH_EVENT.EMBEDDED_AUTH_FAILED],
    () => {
      setIsRefreshingSignIn(false);
    }
  );

  useEffect(() => {
    if (isRefreshingSignIn) {
      return;
    }

    const intervalId = setInterval(() => {
      setTitleKey(pickRandomTitleKey());
    }, TIMEOUT_DELAY.EMBEDDED_TITLE_CHANGE);

    return () => clearInterval(intervalId);
  }, [isRefreshingSignIn]);

  const displayTitle = isRefreshingSignIn
    ? t(
        'embedded_auth.please_wait_while_we_verify_your_session_this_should_only_take_a_few_seconds'
      )
    : t(titleKey);

  return (
    <div className='fixed w-screen h-screen bg-bear bg-no-repeat bg-center bg-fixed bg-contain'>
      <div className='fixed inset-0 dark:bg-gray-800/90 bg-white/95'></div>
      <div className='w-full h-full flex items-center justify-center text-primary-900'>
        <p
          key={displayTitle}
          className='w-fit h-fit animate-pulse ~text-lg/3xl ~px-2/8 text-center'>
          {displayTitle || t('initializing_embedded_services')}
        </p>
      </div>
    </div>
  );
};

export default InitEmbeddedServices;
